export default __webpack_public_path__ + "_/images/app/apk/apk-5-565f38eaad131321c7b487958be06dbe65d1ed6efee2c80f3c5bceef78f3fa0e.png";